import { render, staticRenderFns } from "./AuthorizedClients.vue?vue&type=template&id=1a6c22aa&scoped=true&"
import script from "./AuthorizedClients.vue?vue&type=script&lang=js&"
export * from "./AuthorizedClients.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedClients.vue?vue&type=style&index=0&id=1a6c22aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c22aa",
  null
  
)

export default component.exports